import { useMutation } from '@hooks/reactQuery';

import { checkPhoneNumberFor2Fa } from '@api/userProfile';

import { IOnOpen } from '@interfaces/common/handlers';
import { ICheckPhoneNumberDTO } from '@interfaces/user/dto/userProfileDTO';

import { CHECK_PHONE_NUMBER } from '@constants/queryKeys';

export const useMutateCheckPhoneNumber = ({ onOpen }: IOnOpen) => {
	const {
		mutate: checkPhoneNumber,
		isLoading: isLoadingCheckPhoneNumber,
	} = useMutation<ICheckPhoneNumberDTO>({
		mutationKey: [CHECK_PHONE_NUMBER],
		mutationFn: checkPhoneNumberFor2Fa,
		onSuccess: () => {
			onOpen();
		},
	});

	return {
		checkPhoneNumber,
		isLoadingCheckPhoneNumber,
	};
};
